import {
  DefaultProfile,
} from '../implementations';

const mappers = {
  default_profile: DefaultProfile,
};

export default mappers;
